import { Box } from "@chakra-ui/react";
import Script from "next/script";

interface Props {
  id: String;
}

export default function TallyForm(props: Props) {
  return (
    <Box position="relative">
      <>
        <iframe
          data-tally-src={`https://tally.so/embed/${props.id}?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1`}
          width="100%"
          height="284"
          title="Contact form"
          min-height="70px"
        ></iframe>

        <Script
          id="tally-js"
          src="https://tally.so/widgets/embed.js"
          onLoad={() => {
            const tally = (window as any).Tally;
            tally?.loadEmbeds();
          }}
        />
      </>
      <Box
        position="absolute"
        right="0"
        bottom="0"
        w={{ base: "60px", sm: "300px" }}
        h="70px"
        bg="white"
      ></Box>
    </Box>
  );
}
